import React from 'react';

import { Chip, ChipProps } from '@mui/material';

const AVAILABLE_STATUSES = ['PENDING', 'EXPIRED'];

// Temporary flag to hide available status in prod until feature released.
// TODO: remove as part of ticket https://aussiecommerce.atlassian.net/browse/LEBT-2153
const isProduction = process.env.NODE_ENV === 'production';

export function getDisplayStatus(status: string): string {
  if (!status) {
    return '';
  }
  if (!isProduction && AVAILABLE_STATUSES.includes(status)) {
    return 'AVAILABLE';
  }
  return status.toUpperCase();
}

const STATUS_COLOR_MAP: Record<string, ChipProps['color']> = {
  AVAILABLE: 'warning',
  PENDING: 'warning',
  ACTIVATED: 'success',
};

function getStatusColor(displayStatus: string): ChipProps['color'] {
  return STATUS_COLOR_MAP[displayStatus] ?? 'error';
}

export default function EmployeeStatusCell({ status }: { status: string }) {
  const displayStatus = getDisplayStatus(status);
  if (!displayStatus) {
    return null;
  }
  return <Chip label={displayStatus} color={getStatusColor(displayStatus)} size="small" />;
}
